<template>
  <QDialog v-model="showDialog" full-height no-esc-dismiss persistent>
    <QCard style="padding: 0 0 25px 0; width: 700px; max-width: 100vw">
      <QCardSection class="row justify-end q-pb-none">
        <QBtn flat outline round color="grey-9" class="self-start" @click="onCancel" :icon="close" />
      </QCardSection>
      <div class="row justify-center items-center" style="width: 100%; padding: 0 10px">
        <div class="col-12" style="text-align: center">
          <h5>Company Lookup</h5>
          <p v-if="region === 'NZ'">Enter your NZBN or company name</p>
          <p v-else>Enter your ABN or company name</p>
        </div>
        <div class="col-md-9 col-sm-6" style="text-align: center">
          <InputField
            :placeholder="region === 'NZ' ? 'Enter your NZBN or company name' : 'Enter your ABN or company name'"
            v-model.lazy="companySearch"
          />
        </div>
        <div class="col-md-3 col-sm-4" style="text-align: center">
          <QBtn
            color="primary"
            no-caps
            outline
            :loading="companySearchLoading"
            :disable="!companySearch || companySearch.length < 4"
            :ripple="false"
            @click.prevent="onSearchForCompany"
            >Search</QBtn
          >
        </div>
        <div class="col-12" style="text-align: left; padding: 0 10px">
          <div v-if="getBusinessInfo && getBusinessInfo.rows && getBusinessInfo.rows.length" style="padding-top: 25px">
            <div class="row q-col-gutter-md" v-for="company in getBusinessInfo.rows" :key="company.abn">
              <div class="col-12" style="cursor: pointer">
                <div
                  v-on:click="companySelected = company"
                  :style="[
                    companySelected && companySelected.abn == company.abn ? { background: '#ddeaf3', color: 'var(--primary-color)' } : ''
                  ]"
                >
                  <span style="font-weight: 700"> {{ company.abn }} </span>
                  <br />
                  <span>
                    {{ company.name }} - {{ company.postCode }}
                    {{ company.stateCode }}
                  </span>
                  <hr style="margin: 6px 0px" />
                </div>
              </div>
            </div>
          </div>
          <div v-if="getBusinessInfo && getBusinessInfo.rows && getBusinessInfo.rows.length == 0" style="padding-top: 25px">
            <p>Result is empty.</p>
          </div>
        </div>
      </div>
      <div class="text-center col-12" style="padding-top: 20px">
        <QBtn
          color="primary"
          no-caps
          @click="onSelect()"
          :disable="!(getBusinessInfo && getBusinessInfo.rows && getBusinessInfo.rows.length && companySelected)"
          >Select</QBtn
        >
      </div>
      <div class="text-center col-12" style="padding-top: 20px">
        <QBtn color="primary" flat no-caps @click="onCancel" label="Cancel" />
      </div>
    </QCard>
  </QDialog>
</template>

<script>
import { mapState } from 'vuex';
import InputField from '../../components/Atoms/InputField';
import { QBtn, QDialog, QCard, QCardSection } from 'quasar';
import QueryBusinessLookup from './../../graphql/queries/QueryBusinessLookup';
import { GLOBAL_ERROR } from '../../components/GlobalError/GlobalError';
import { Icons } from 'eclipx.ui';

export default {
  name: 'BusinessLookup',
  components: { QBtn, InputField, QDialog, QCard, QCardSection },
  apollo: {
    getBusinessInfo: {
      query: QueryBusinessLookup,
      debounce: 300,
      fetchPolicy: 'network-only',
      variables() {
        return {
          param: this.companySearchQueryVariable,
          region: this.region
        };
      },
      skip() {
        return !this.companySearchQueryVariable;
      },
      error: function () {
        this.$euiNotifications.emit({
          notification: GLOBAL_ERROR,
          action: () => {
            return this.$apollo.queries.getBusinessInfo.refresh();
          }
        });
      },
      result: function (res) {
        this.companySearchLoading = false;
      }
    }
  },
  data: function () {
    return {
      companySearch: null,
      companySearchQueryVariable: null,
      companySelected: null,
      companySearchLoading: false,
      showDialog: true
    };
  },
  computed: {
    ...mapState({
      scoreboard: (state) => state.vehicleApplication.vehicleApplication.scoreboard
    }),
    region() {
      return this.scoreboard?.currentUser?.region ? this.scoreboard?.currentUser?.region : 'AU';
    }
  },
  created() {
    this.close = Icons.evaClose;
  },
  methods: {
    onCancel: function () {
      setTimeout(() => {
        this.$emit('closeBusinessLookup');
        this.showDialog = false;
      });
    },
    onSelect: function () {
      setTimeout(() => {
        this.$emit('selectBusinessLookup', this.companySelected);
        this.onCancel();
      });
    },
    onSearchForCompany: function () {
      if (this.companySearch && this.companySearch.length > 3) {
        this.companySearchLoading = true;
        if (this.companySearchQueryVariable) {
          this.companySearchQueryVariable = null;
          setTimeout(() => {
            this.companySearchQueryVariable = this.companySearch;
          });
        } else this.companySearchQueryVariable = this.companySearch;
      }
    }
  }
};
</script>
